/* eslint-disable no-restricted-imports */
import {UIGameManagerMethods} from '../../../../code/client/shared/scripts/ui_game/UIGameManager'
import React, {ReactNode, createContext, useContext} from 'react'

const UIGameManagerContext = createContext<UIGameManagerMethods | null>(null)

/**
 * @deprecated Don't use the uiGameManager in ReactJS code
 * To access a property of uiGameManager, pass it in as a prop.
 */
export function UIGameManagerProvider({
    children,
    gameManager,
}: {
    children: ReactNode
    gameManager: UIGameManagerMethods
}) {
    return (
        <UIGameManagerContext.Provider value={gameManager}>
            {children}
        </UIGameManagerContext.Provider>
    )
}

/**
 * @deprecated Don't use the uiGameManager in ReactJS code
 * To access a property of uiGameManager, pass it in as a prop.
 */
export function useUIGameManagerContext() {
    const gameManager = useContext(UIGameManagerContext)
    if(gameManager == null) throw new Error('useGameManager must be used within a UIGameManagerContext')

    return gameManager
}
